import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import SectionPaper from "../../common/SectionPaper";
import { nullToEmptyString } from "../../../setup/helpers";
import { messageShow } from '../../common/api/actions';
import { Typography, Button, TextField, Toolbar, IconButton, FormControl, InputLabel, Select, MenuItem, Switch, Box } from "@mui/material";
import Grid from "@material-ui/core/Grid/Grid";
import ArrowBack from '@mui/icons-material/ArrowBack';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import styles from "./styles";
import FileUpload from '@mui/icons-material/FileUpload';
import { getImageSource } from "../../setting/api/routes";
import ImageComp from "../../common/Image";

import routes from "../api/routes";
import { getbookingSettings } from "../api/actions/query";
import { createOrUpdatebookingSetting } from "../api/actions/mutation";
import { detail } from '../../setting/api/actions/query';
import { upload } from "../../common/api/actions";


class bookingSetting extends Component {
    constructor(props) {
        super(props);

        this.bookingConfig = {
            maxNoOfTable: "",
            tableCapacity: "",
            limitMaxGuests: false,
            maxNoOfGuests: "",
            slotDuration: "",
            vendorId: "",
            bookingHours: [
                {
                    day: "SUN",
                    isBookingClosed: false,
                    bStartTime: '00:00',
                    bEndTime: '12:00',
                    lStartTime: '12:00',
                    lEndTime: '23:59',
                },
                {
                    day: "MON",
                    isBookingClosed: false,
                    bStartTime: '00:00',
                    bEndTime: '12:00',
                    lStartTime: '12:00',
                    lEndTime: '23:59',
                },
                {
                    day: "TUE",
                    isBookingClosed: false,
                    bStartTime: '00:00',
                    bEndTime: '12:00',
                    lStartTime: '12:00',
                    lEndTime: '23:59',
                },
                {
                    day: "WED",
                    isBookingClosed: false,
                    bStartTime: '00:00',
                    bEndTime: '12:00',
                    lStartTime: '12:00',
                    lEndTime: '23:59',
                },
                {
                    day: "THU",
                    isBookingClosed: false,
                    bStartTime: '00:00',
                    bEndTime: '12:00',
                    lStartTime: '12:00',
                    lEndTime: '23:59',
                },
                {
                    day: "FRI",
                    isBookingClosed: false,
                    bStartTime: '00:00',
                    bEndTime: '12:00',
                    lStartTime: '12:00',
                    lEndTime: '23:59',
                },
                {
                    day: "SAT",
                    isBookingClosed: false,
                    bStartTime: '00:00',
                    bEndTime: '12:00',
                    lStartTime: '12:00',
                    lEndTime: '23:59',
                },
            ],
            reservationSpace: "",
        };

        this.state = {
            isLoading: false,
            bookingConfig: this.bookingConfig,
            holidays: {},
            previewImage: null,
            isUploadingFile: false,  
            permissions: props.location.state?.permissions || { canEdit: false }
        }
    }
    
    
    async componentDidMount() {
        this.refresh();
        this.fetchSettings();
    }

    fetchSettings = async () => {
        const { detail } = this.props;
        const { vendorId } = this.state;
        this.isLoadingToggle(true);

        try {
            const { data } = await detail({ vendorId })
            if (data.success && data.data) {
                const holidays = {};
                (data.data.workingHours || []).forEach(day => {
                    holidays[day.day] = day.isHoliday;
                });
                this.setState({ holidays });
            }
        } catch (error) {
            console.error('Error fetching setting details:', error);
            messageShow('Error fetching settings');
        }finally {
            this.isLoadingToggle(false);
        }
    }
    
    refresh = async () => {
        const { getbookingSettings, messageShow } = this.props;

        this.isLoadingToggle(true);

        try {
            const { data } = await getbookingSettings();
            if (data.success && data.data) {
                this.setState({
                    bookingConfig: data.data,
                });
            }
        } catch (error) {
            console.error("Error fetching booking settings: ", error);
            messageShow("Some error occurred. Please try again.");
        } finally {
            this.isLoadingToggle(false);
        }
    };

    isLoadingToggle = (isLoading) => {
        this.setState({
            isLoading,
        });
    };

    onType = ({ target: { name, value } }) => {
        this.setState((prevState) => ({
            bookingConfig: {
                ...prevState.bookingConfig,
                [name]: value,
            },
        }));
    };

    onCreateOrUpdate = async (event) => {
        event.preventDefault();

        const { createOrUpdatebookingSetting, messageShow, history } = this.props;
        const { bookingConfig } = this.state;
        this.isLoadingToggle(true);

        if (bookingConfig.limitMaxGuests  && !bookingConfig.maxNoOfGuests) {
          messageShow("Please enter maximum number of guests.");
          this.isLoadingToggle(false);
          return;
        }
        try {
            const { data } = await createOrUpdatebookingSetting(bookingConfig);

            if (data.success) {
                messageShow(data.message);
                this.refresh();
                history.push(routes.bookingsList.path);
            } else {
                messageShow("Failed to save table booking settings.");
            }
        } catch (error) {
            console.error("Error saving table booking settings:", error);
            messageShow("Some error occurred. Please try again.");
        } finally {
            this.isLoadingToggle(false);
        }
    };
    
    onUpload = async (event) => {
      const { upload, messageShow } = this.props;
      messageShow("Uploading file, please wait...");
      this.isUploadingFileToggle(true);

      let file = new FormData();
      file.append("type", "tableBooking");
      file.append("name", "reservationSpace");
      file.append("file", event.target.files[0]);

      const fileReader = new FileReader();
      fileReader.onload = () => {
        const fileResult = fileReader.result;
        let dataAsImg = new Image();
        dataAsImg.src = fileResult;
        this.setState({ previewImage: dataAsImg.src });
      };
      fileReader.readAsDataURL(event.target.files[0]);

      try {
        const { data } = await upload(file);

        if (data.success) {
           messageShow("File uploaded successfully.");
           const { bookingConfig } = this.state;

            setTimeout(() => {
              bookingConfig.reservationSpace = data.file;
              this.setState({
                bookingConfig,
            });
        }, 1000);
      } else {
        messageShow("failed to upload image");
      }
      } catch (error) {
        console.error("Error uploading file: ", error);
        messageShow("Error on uploading reservation Space Image");
      } finally {
        this.isUploadingFileToggle(false);
      }
    };

    isUploadingFileToggle = (isUploadingFile) => {
      this.setState({
        isUploadingFile,
      });
    };

    render() {
        const { classes } = this.props;
        const { bookingConfig, holidays, isUploadingFile, previewImage, permissions } = this.state;
        const dayMapping = {
            SUN: "Sunday",
            MON: "Monday",
            TUE: "Tuesday",
            WED: "Wednesday",
            THU: "Thursday",
            FRI: "Friday",
            SAT: "Saturday"
        };
    
        return (
            <div>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        className={classes.menuButton}
                        color="inherit"
                        onClick={() => this.props.history.push("/table-bookings")}
                    >
                        <ArrowBack />
                    </IconButton>

                    <Typography variant="h6" sx={{ color: '#0d3559', fontWeight: 600 }} className={classes.grow}>
                        Table Booking Settings
                    </Typography>
                </Toolbar>

                <Grid item xs={12} lg={6}>
                    <SectionPaper padding>
                        <form onSubmit={this.onCreateOrUpdate}>
                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"maxNoOfTable"}
                                    variant="standard"
                                    value={nullToEmptyString(bookingConfig?.maxNoOfTable)}
                                    onChange={this.onType}
                                    label={"Maximum Tables per Time Slot"}
                                    placeholder={"Enter Maximum Tables per Time Slot"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    autoFocus
                                    required
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <TextField
                                    name={"tableCapacity"}
                                    variant="standard"
                                    value={nullToEmptyString(bookingConfig?.tableCapacity)}
                                    onChange={this.onType}
                                    label={"Table Capacity"}
                                    placeholder={"Enter Table Capacity"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    required
                                    disabled={!permissions.canEdit}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: 24 }}>
                                <FormControl fullWidth variant="standard" margin="dense" disabled={!permissions.canEdit}>
                                    <InputLabel id="slotDuration-label">Slot Duration (Minutes)</InputLabel>
                                    <Select
                                        labelId="slotDuration-label"
                                        name="slotDuration"
                                        value={bookingConfig?.slotDuration || ''}
                                        onChange={this.onType}
                                        required
                                        disabled={!permissions.canEdit}
                                    >
                                        <MenuItem value={15}>15</MenuItem>
                                        <MenuItem value={30}>30</MenuItem>
                                        <MenuItem value={45}>45</MenuItem>
                                        <MenuItem value={60}>60</MenuItem>
                                        <MenuItem value={120}>120</MenuItem>
                                        <MenuItem value={180}>180</MenuItem>
                                        <MenuItem value={240}>240</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                              
                             <Grid item xs={12} style={{ marginBottom: 12 }}>
                              <Box display="flex" alignItems="center" mb={2}>
                                <Switch
                                 checked={bookingConfig.limitMaxGuests}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    this.setState((prev) => ({
                                      bookingConfig: {
                                        ...prev.bookingConfig,
                                        limitMaxGuests: checked,
                                        maxNoOfGuests: checked ? prev.bookingConfig.maxNoOfGuests : "", 
                                      }
                                    }));
                                  }}
                                  disabled={!permissions.canEdit}
                                />
                                <Typography variant="body1">Limit Maximum Number of Guests</Typography>
                               </Box>
                            </Grid>
                          
                            {bookingConfig.limitMaxGuests && (
                                <Grid item xs={12} style={{ marginBottom: 24 }}>
                                  <TextField
                                    name={"maxNoOfGuests"}
                                    variant="standard"
                                    value={nullToEmptyString(bookingConfig?.maxNoOfGuests)}
                                    onChange={this.onType}
                                    label={"Maximum No of Guests"}
                                    placeholder={"Enter Maximum No of Guests"}
                                    margin={"dense"}
                                    autoComplete={"off"}
                                    fullWidth
                                    disabled={!permissions.canEdit}
                                  />
                               </Grid> 
                            )}

                            <Grid container spacing={2} style={{ marginTop: 24, marginBottom: 24 }}>
                                <Grid item xs={12}>
                                    <Typography variant="h6">Booking Hours</Typography>
                                </Grid>

                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    {(bookingConfig.bookingHours || []).map((dayConfig, index) => (
                                        <Grid
                                            container
                                            spacing={2}
                                            alignItems="center"
                                            key={dayConfig.day}
                                            style={{ marginTop: 12 }}
                                        >
                                            {/* Day Name */}
                                            <Grid item xs={4} style={{ paddingLeft: 16 }}>
                                                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                                    {dayMapping[dayConfig.day]}
                                                </Typography>
                                            </Grid>

                                            {/* Toggle Switch */}
                                            <Grid item xs={4}>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <Typography variant="body2">Close Booking</Typography>
                                                    <Switch
                                                        checked={
                                                            holidays[dayConfig.day] 
                                                                ? true 
                                                                : dayConfig.isBookingClosed
                                                        }
                                                        onChange={(e) => {
                                                            if (holidays[dayConfig.day]) {
                                                                return;
                                                            }
                                                            const updatedBookingHours = [...bookingConfig.bookingHours];
                                                            updatedBookingHours[index].isBookingClosed = e.target.checked;
                                                            this.setState(prev => ({
                                                                bookingConfig: {
                                                                    ...prev.bookingConfig,
                                                                    bookingHours: updatedBookingHours,
                                                                }
                                                            }));
                                                        }}
                                                        disabled={!permissions.canEdit || holidays[dayConfig.day]} 
                                                    />
                                                </Box>
                                            </Grid>

                                            {/* Morning Start Time */}
                                            <Grid container item xs={12} spacing={2} style={{ paddingLeft: 16 }}>
                                                <Grid item xs={12} md={4}>
                                                    <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                                                        Morning Hours
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={6} md={4}>
                                                    <TimePicker
                                                        label="Start Time"
                                                        value={dayConfig.bStartTime ? dayjs(dayConfig.bStartTime, "HH:mm") : null}
                                                        onChange={(newValue) => {
                                                            const updatedBookingHours = [...bookingConfig.bookingHours];
                                                            updatedBookingHours[index].bStartTime = newValue ? newValue.format("HH:mm") : null;
                                                            this.setState(prev => ({
                                                                bookingConfig: {
                                                                    ...prev.bookingConfig,
                                                                    bookingHours: updatedBookingHours,
                                                                }
                                                            }));
                                                        }}
                                                        disabled={!permissions.canEdit || dayConfig.isBookingClosed}
                                                        slotProps={{
                                                            textField: { fullWidth: true, size: 'small' }
                                                        }}
                                                    />
                                                </Grid>

                                                {/* Morning End Time */}
                                                <Grid item xs={6} md={4}>
                                                    <TimePicker
                                                        label="End Time"
                                                        value={dayConfig.bEndTime ? dayjs(dayConfig.bEndTime, "HH:mm") : null}
                                                        onChange={(newValue) => {
                                                            const updatedBookingHours = [...bookingConfig.bookingHours];
                                                            updatedBookingHours[index].bEndTime = newValue ? newValue.format("HH:mm") : null;
                                                            this.setState(prev => ({
                                                                bookingConfig: {
                                                                    ...prev.bookingConfig,
                                                                    bookingHours: updatedBookingHours,
                                                                }
                                                            }));
                                                        }}
                                                        minTime={
                                                            dayConfig.bStartTime ? dayjs(dayConfig.bStartTime, "HH:mm") : null
                                                        }
                                                        disabled={!permissions.canEdit || dayConfig.isBookingClosed}
                                                        slotProps={{
                                                            textField: { fullWidth: true, size: 'small' }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* Evening Start Time */}
                                            <Grid container item xs={12} spacing={2} style={{ paddingLeft: 16, marginTop: 8 }}>
                                                <Grid item xs={12} md={4} style={{ marginTop: 16 }}>
                                                    <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                                                        Evening Hours
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={6} md={4}>
                                                    <TimePicker
                                                        label="Start Time"
                                                        value={dayConfig.lStartTime ? dayjs(dayConfig.lStartTime, "HH:mm") : null}
                                                        onChange={(newValue) => {
                                                            const updatedBookingHours = [...bookingConfig.bookingHours];
                                                            updatedBookingHours[index].lStartTime = newValue ? newValue.format("HH:mm") : null;
                                                            this.setState(prev => ({
                                                                bookingConfig: {
                                                                    ...prev.bookingConfig,
                                                                    bookingHours: updatedBookingHours,
                                                                }
                                                            }));
                                                        }}
                                                        disabled={!permissions.canEdit || dayConfig.isBookingClosed}
                                                        minTime={
                                                            dayConfig.bEndTime ? dayjs(dayConfig.bEndTime, "HH:mm") : dayjs('06:00', "HH:mm")
                                                        }
                                                        slotProps={{
                                                            textField: { fullWidth: true, size: 'small' }
                                                        }}
                                                    />
                                                </Grid>

                                                {/* Evening End Time */}
                                                <Grid item xs={6} md={4}>
                                                    <TimePicker
                                                        label="End Time"
                                                        value={dayConfig.lEndTime ? dayjs(dayConfig.lEndTime, "HH:mm") : null}
                                                        onChange={(newValue) => {
                                                            const updatedBookingHours = [...bookingConfig.bookingHours];
                                                            updatedBookingHours[index].lEndTime = newValue ? newValue.format("HH:mm") : null;
                                                            this.setState(prev => ({
                                                                bookingConfig: {
                                                                    ...prev.bookingConfig,
                                                                    bookingHours: updatedBookingHours,
                                                                }
                                                            }));
                                                        }}
                                                        minTime={
                                                            dayConfig.lStartTime ? dayjs(dayConfig.lStartTime, "HH:mm") : null
                                                        }
                                                        disabled={!permissions.canEdit || dayConfig.isBookingClosed}
                                                        slotProps={{
                                                            textField: { fullWidth: true, size: 'small' }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </LocalizationProvider>
                            </Grid>

                             <Grid>
                                <Grid item xs={12}>
                                  <Typography variant="h6">Reservation Space</Typography>
                                </Grid>
                                <Grid
                                    container
                                    spacing={10}
                                    className={classes.buttonUpload}
                                    alignItems="center"
                                >
                                    <Grid item md={6}>
                                        {!previewImage ? (
                                            <ImageComp
                                                src={getImageSource(`${bookingConfig.reservationSpace}`)}
                                                defaultSrc={getImageSource()}
                                                size={"100%"}
                                            />
                                        ) : (
                                            <img
                                                height="auto"
                                                width="100%"
                                                src={previewImage}
                                                alt="preview_banner"
                                            ></img>
                                        )}
                                    </Grid>
                                    <Grid item md={6}>
                                        <input
                                            accept={"image/png,image/jpeg"}
                                            style={{ display: "none" }}
                                            id={"reservation-contained-button-file"}
                                            type={"file"}
                                            onChange={this.onUpload}
                                            disabled={!permissions.canEdit}
                                        />
                            
                                        <label htmlFor={"reservation-contained-button-file"}>
                                            <Button
                                                variant={"outlined"}
                                                component={"span"}
                                                type={"file"}
                                                fullWidth
                                                disabled={isUploadingFile || !permissions.canEdit}
                                            >
                                                <FileUpload
                                                    fontSize="16"
                                                    style={{ marginInlineEnd: 16 }}
                                                />
                                                Upload Image
                                            </Button>
                                        </label>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: 44 }} className={classes.buttonsContainer}>
                                <Button
                                    type={"button"}
                                    aria-label={"Close"}
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => this.props.history.push("/table-bookings")}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    style={{ marginInlineStart: 12 }}
                                    type={"submit"}
                                    aria-label={"Save"}
                                    color={"primary"}
                                    variant="contained"
                                    disabled={!permissions.canEdit}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </form>
                    </SectionPaper>
                </Grid>
            </div>
        );
    }
}

bookingSetting.propTypes = {
    messageShow: PropTypes.func.isRequired,
    getbookingSettings: PropTypes.func.isRequired,
    createOrUpdatebookingSetting: PropTypes.func.isRequired,
    detail: PropTypes.func.isRequired,
};

export default connect(null, { messageShow, getbookingSettings, createOrUpdatebookingSetting, detail, upload})(
    withRouter(withStyles(styles)(bookingSetting))
);